import pubsub from 'sweet-pubsub';
import { AmplitudeLogger, EVENTS } from "../utils";
export const useCti = () => {
    let phoneNumber = null;
    let isLoggedIn = false;
    const client = ZAFClient.init();
    client.set('iconSymbol', 'mySymbol');
    client.invoke('resize', { width: '320px', height: '460px' });
    client.on('voice.dialout', function ({ from, number, userId }) {
        if (number) {
            phoneNumber = number;
        }
        client.invoke('popover');
        if (isLoggedIn) {
            pubsub.emit('initiate_call', phoneNumber);
        }
        AmplitudeLogger.log(EVENTS.INIT_CALL, { from, number, userId });
    });
    pubsub.on('login', ({ mobile, email, first_name, last_name }) => {
        isLoggedIn = true;
        if (phoneNumber) {
            setTimeout(() => {
                pubsub.emit('initiate_call', phoneNumber);
            }, 1000);
        }
        AmplitudeLogger.log(EVENTS.LOGIN, { mobile, email, first_name, last_name });
    });
    pubsub.on('number_selected', ({}) => {
        AmplitudeLogger.log(EVENTS.NUMBER_SELECTED, { phoneNumber });
        if (phoneNumber) {
            pubsub.emit('initiate_call', phoneNumber);
        }
    });
    pubsub.on('call_ringing', ({ peer }) => {
        if (peer) {
            client.invoke('popover');
        }
    });
    pubsub.on('call_started', ({ direction, peer }) => {
        const callStartTime = Date.now();
        const payload = {
            callStartTime,
            direction,
            phoneNumber: peer
        };
        AmplitudeLogger.log(EVENTS.CALL_STARTED, payload);
    });
    pubsub.on('call_ended', ({ direction, peer, duration, notes }) => {
        AmplitudeLogger.log(EVENTS.CALL_ENDED, { direction, peer, duration, notes });
    });
    pubsub.on('logout', () => {
        isLoggedIn = false;
        AmplitudeLogger.log(EVENTS.LOGOUT, {});
    });
    return client;
};
